import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  ChainNameOption,
  ChainOrderColumn,
  ChainsApiResponse,
  ChainSecurityConfigApiResponse,
  ChainSecurityConfigPayload,
} from '../models/chain.model';

@Injectable({ providedIn: 'root' })
export class ChainsService {
  private readonly http = inject(HttpClient);

  getChains(
    page: number,
    pageSize: number,
    textFilter?: string,
    chainId?: number,
    orderColumn: ChainOrderColumn = 'propertiesCount',
    asc = false,
  ): Observable<ChainsApiResponse> {
    const url = `${environment.customerPath}chains`;
    let params = new HttpParams().set('order_column', orderColumn).set('asc', String(asc));

    params =
      pageSize > 0
        ? params.set('paged', 'true').set('page', String(page)).set('page_size', String(pageSize))
        : params.set('paged', 'false');

    if (chainId !== undefined) {
      params = params.set('chain_id', String(chainId));
    } else if (textFilter) {
      params = params.set('text_filter', textFilter);
    }

    return this.http.get<ChainsApiResponse>(url, { params });
  }

  searchChains(textFilter?: string, chainId?: number): Observable<ChainsApiResponse> {
    const url = `${environment.customerPath}chains`;
    let params = new HttpParams().set('paged', 'false');

    if (chainId !== undefined) {
      params = params.set('chain_id', String(chainId));
    } else if (textFilter) {
      params = params.set('text_filter', textFilter);
    }

    return this.http.get<ChainsApiResponse>(url, { params });
  }

  getSecurityConfig(chainId: number): Observable<ChainSecurityConfigApiResponse> {
    const url = `${environment.customerPath}chains/${chainId}/config`;
    return this.http.get<ChainSecurityConfigApiResponse>(url);
  }

  saveSecurityConfig(chainId: number, payload: ChainSecurityConfigPayload): Observable<unknown> {
    const url = `${environment.customerPath}chains/${chainId}/config`;
    return this.http.put(url, payload);
  }

  getChainNames(): Observable<ChainNameOption[]> {
    const url = `${environment.customerPath}commons/chain/name/list`;
    return this.http.get<ChainNameOption[]>(url);
  }

  createChain(name: string): Observable<number | null> {
    const url = `${environment.customerPath}commons/chain/name`;
    return this.http.post<number | null>(url, { name });
  }
}
